export const mixPanelEvents = {
  VIEW_OFFER_CAD_CARDAPIO: "View Offer Cad Cardapio",
  CLICK_OFFER_CAD_CARDAPIO: "Click Offer Cad Cardapio",
  COPY_LINK_FROM_DASHBOARD: "Copy Link From Dashboard",
  GO_TO_ORDER_MANAGER: "Go to Order Manager",
  OPEN_MENU: "Open Menu",
  INSTALL_APP: "Install App",
};
